import React from "react";
import { Link } from "react-router-dom";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-[60vh] p-8">
          <div className="bg-white rounded-xl shadow-lg p-10 max-w-md w-full text-center">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              Une erreur est survenue
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              {this.state.error?.message || "Erreur inattendue dans ce composant."}
            </p>
            <div className="flex flex-wrap gap-3 justify-center">
              <button
                onClick={this.handleReset}
                className="px-5 py-2.5 rounded-lg text-sm font-semibold bg-gradient-to-r from-blue-500 to-green-500 text-white border-none cursor-pointer hover:opacity-90 transition-opacity"
              >
                Réessayer
              </button>
              <Link
                to="/dashboard"
                className="px-5 py-2.5 rounded-lg text-sm font-semibold bg-gray-100 text-gray-700 border border-gray-300 no-underline hover:bg-gray-200 transition-colors"
              >
                Retour au tableau de bord
              </Link>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
